import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import CheckValue from "../../../../Utils/CheckValue/CheckValue";

export default function High(props) {
  const socket = useContext(SocketContext);
  const symbol_id = props.symbol_id;

  const [high, setHigh] = useState(0);

  useEffect(() => {
    if (!symbol_id) return;

    socket.emit("giverate", symbol_id);

    const trade = (data) => {
      if (data != null && data.High !== undefined) {
        setHigh(data.High);
      }
    };

    socket.on("trade" + symbol_id, trade);

    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id]);

  return (
    <div className="menuHigh">
      <CheckValue number={high} />
    </div>
  );
}
